import Entry from "./Entry";

export default class Circuit extends Entry {
  static type = "circuits";

  get type(): string {
    return Circuit.type;
  }
}
